/**
 * Banner d'errore standard dell'app: una sola tinta, una sola spaziatura,
 * sempre annunciato agli screen reader.
 *
 * `className` serve SOLO al posizionamento nel layout che lo ospita (margini,
 * larghezza, display, ombra): tinta, bordo, padding e corpo del testo li
 * decide il componente, altrimenti tornano le 20 varianti di prima.
 */
type ErrorBannerProps = {
  /** Messaggio da mostrare. Se assente il banner non viene renderizzato. */
  message?: string | null;
  /** Classi di posizionamento del call-site (es. `mb-3`, `inline-flex`). */
  className?: string;
};

export function ErrorBanner({ message, className }: ErrorBannerProps) {
  // ponytail: la guardia sta qui, così i call-site perdono il loro `{error && ...}`.
  if (!message) return null;
  return (
    <div
      role="alert"
      className={`rounded-md border border-red/20 bg-red-soft px-3 py-2 text-[12.5px] text-ink ${className ?? ""}`}
    >
      {message}
    </div>
  );
}
